// Section 18: Child labour policy. Never / From 12 in emergencies / From 12 always; loosening costs trust -4. Emergency = any shortage last season.
// Default: config.policies.defaults.childLabour.
import type { Config } from '../../config';
import { noProblem } from '../../core/content-helpers';
import { ageYears, isChild, peopleSorted } from '../../core/queries';
import { definePolicy, noModifiers } from '../../core/registry';

export function childLabour(config: Config) {
  const RANK = { never: 0, emergencies: 1, always: 2 } as const;

  return definePolicy({
    id: 'childLabour',
    label: 'Child labour',
    section: 'S18',
    group: 'work',
    options: ['never', 'emergencies', 'always'],
    default: config.policies.defaults.childLabour,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: (from, to) =>
      RANK[to] > RANK[from] ? config.policies.childLabourLoosenedTrust : 0,
    // M6: the preview names the children the policy is about (aged 12 to 14).
    affects(ctx, option) {
      const from = config.work.childWorkFromYears;
      const children = peopleSorted(ctx.state).filter(
        (p) => isChild(config, p) && ageYears(config, p.ageSeasons) >= from,
      ).length;
      return [{ key: `policy.childLabour.${option}`, params: { children, from } }];
    },
    validate: noProblem,
  });
}
